export default __webpack_public_path__ + "share-2.svg";